let language = {
    ORDER_GENERATE_PENDING_TITLE: "订单{{combineOrderId}}正在生成中，请稍等。订单生成后，系统将自动跳转至付款页面",
    ORDER_GENERATE_PENDING_DESCRIPTION_FRONT: '如果你已配置了自动付款，你可以关闭当前窗口，无需在此等待；如果你不小心关闭了页面，可请往“',
    ORDER_GENERATE_PENDING_DESCRIPTION_LINK: 'Partner Orders',
    ORDER_GENERATE_PENDING_DESCRIPTION_END: '”查看此订单'
};

export { language }